import { render, staticRenderFns } from "./integrationMessageTest.vue?vue&type=template&id=77653cce&"
import script from "./integrationMessageTest.vue?vue&type=script&lang=js&"
export * from "./integrationMessageTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports